import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-time-popup',
  templateUrl: './time-popup.component.html',
  styleUrls: ['./time-popup.component.scss']
})
export class TimePopupComponent implements OnInit {
  count:any;
  constructor(public dialogRef: MatDialogRef<TimePopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    data.cancelButtonName = data.cancelButtonName ? data.cancelButtonName : "Cancel";

  }
  ngOnInit() {
  }
  
  cancelClickHandle(event : any) {
   // this.dialogRef.close();
   this.dialogRef.close({ clickedCancel: true });
  }

}
